import months from './months.js'
import {format, parse} from 'date-fns'

const LOCAL_DATE_FORMAT = 'yyyy-MM-dd'
const DISPLAY_DATE_FORMAT = 'dd MMM yyyy'

export function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z0-9]{2,}))$/;
    return re.test(String(email).trim().toLowerCase());
}

export function localDateToDisplayDate(localDate) {
    if (!localDate) return localDate
    return format(parse(localDate, LOCAL_DATE_FORMAT, new Date()), DISPLAY_DATE_FORMAT)
}

export function displayDateToLocalDate(displayDate) {
    if (!displayDate) return displayDate
    return format(parse(displayDate, DISPLAY_DATE_FORMAT, new Date()), LOCAL_DATE_FORMAT)
}

export function date(date, flag){
    if (date === null){
        return null
    }
    let tempDate
    if(flag === 'd'){
        tempDate = new Date(date)
        return tempDate.getDate() + ' ' + months[tempDate.getMonth()].abbreviation + ' ' + tempDate.getFullYear()
    } else if (flag === 's'){
        tempDate = new Date(date)
        return date.split('.')[0] + '.' + date.split('.')[1] + '.' + date.split('.')[2][2] + date.split('.')[2][3]
    } else if (flag === 'sl'){
        tempDate = new Date(date)
        let month = tempDate.getMonth() + 1;
        if(month < 10){
            month = '0' + month
        }
        let day = tempDate.getDate()
        if(day < 10){
            day = '0' + day
        }
        return day + '/' + month + '/' + tempDate.getFullYear().toString()[2] + tempDate.getFullYear().toString()[3]
    } else if (flag === 'start'){
        tempDate = new Date(date)
        let month = tempDate.getMonth() + 1;
        if(month < 10){
            month = '0' + month
        }
        let day = tempDate.getDate()
        if(day < 10){
            day = '0' + day
        }
        return day + '.' + month + '.' + tempDate.getFullYear()
    } else if (flag === 'norm'){
        tempDate = new Date(date)
        let month = tempDate.getMonth() + 1;
        if(month < 10){
            month = '0' + month
        }
        let day = tempDate.getDate()
        if(day < 10){
            day = '0' + day
        }
        return tempDate.getFullYear() + '-' + month + '-' + day
    } else if (flag === 'fromStart'){
        let month = +date.split('.')[1] - 1;
        return date.split('.')[0] + ' ' + months[month].abbreviation + ' ' + date.split('.')[2]
    }
}
